interface StepIndicatorProps {
  currentStep: number;
  steps: string[];
}

export function StepIndicator({ currentStep, steps }: StepIndicatorProps) {
  return (
    <div className="step-indicator">
      {steps.map((label, index) => {
        const stepNum = index + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;

        return (
          <div key={stepNum} className="step-indicator__step">
            {index > 0 && (
              <div
                className={`step-indicator__connector${
                  isCompleted ? ' step-indicator__connector--completed' : ''
                }`}
              />
            )}
            <div
              className={`step-indicator__circle${
                isActive ? ' step-indicator__circle--active' : ''
              }${isCompleted ? ' step-indicator__circle--completed' : ''}`}
            >
              {isCompleted ? '\u2713' : stepNum}
            </div>
            <span
              className={`step-indicator__label${
                isActive ? ' step-indicator__label--active' : ''
              }`}
            >
              {label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
